import React from "react";
import {
  AddIcon,
  CloudIcon,
  DownloadIcon,
  FilterIcon,
} from "../../../assets/icons/index.js";
import DataDropdown from "../../DataDropdown";
import jsonToXlsx from "../../../helpers/formTools/transformations/jsonToXlsx";

export const subHeaderRightNavOptions = (
  userCanCreate,
  data,
  handleFilterIconClick,
  navigate
) => ({
  icons: [
    false && {
      icon: <CloudIcon fillColor="var(--archeo-color)" />,
      onClick: () => {
        console.log("Upload");
      },
      label: "Upload",
    },
    userCanCreate && {
      icon: <AddIcon fillColor="var(--archeo-color)" />,
      label: "Aggiungi",
      onClick: () => {
        navigate("/archivio/add");
        return null;
      },
    },
    {
      icon: <FilterIcon fillColor="var(--archeo-color)" />,
      onClick: handleFilterIconClick,
      label: "Filtro",
    },
    {
      icon: <DownloadIcon fillColor="var(--archeo-color)" />,
      label: "Scarica lista",
      onClick: () => {
        const jsonArr = data.map(({ actions, ...rest }) => rest);
        jsonToXlsx(jsonArr, "pubblicazioni.xlsx");
      },
    },
  ],
  components: [<DataDropdown defaultSelected="ARCHIVIO STORICO" />],
});
